export const SWISS_ID = 'swiss_id';
export const SWISS_PASSPORT = 'swiss_passport';
export const WORK_PERMIT_L = 'work_permit_l';
export const WORK_PERMIT_B = 'work_permit_b';
export const WORK_PERMIT_C = 'work_permit_c';
export const WORK_PERMIT_G = 'work_permit_g';
export const DIPLOMATIC_PASSPORT = 'diplomatic_passport';

export const getIdentityDocumentsTypes = t => [
  {
    label: t('ids.swissId', 'Swiss ID'),
    value: SWISS_ID,
    reqexp: /^[A-Za-z]\d[A-Za-z]\d{2}[A-Za-z]\d{2}$|^\d{9}$|^[A-Za-z]\d{7}$/,
    formats: ['999999999', 'A9999999', 'A9A99A99'],
  },
  {
    label: t('ids.swissPassport', 'Swiss Passport'),
    value: SWISS_PASSPORT,
    reqexp: /^[A-Za-z]\d[A-Za-z]\d{2}[A-Za-z]\d{2}$|^\d{9}$|^[A-Za-z]\d{7}$/,
    formats: ['999999999', 'A9999999', 'A9A99A99'],
  },
  {
    label: t('ids.work_permit_l', 'Work permit L'),
    value: WORK_PERMIT_L,
    reqexp:
      /^\d{4}\.\d{4}\/\d$|\d{3}\.\d{3}\.\d{3}-\d$|\d{9}\.\d$|[A-Z]{2}\d{6}$|\d{4}\/\d{1}$|\d{7}\.\d$|\d{8}\.\d$/,
    formats: [
      '1234.1234/1',
      '123.123.123-1',
      '123456789.1',
      '1234/1',
      '1234567.1',
      '12345678.1',
    ],
  },
  {
    label: t('ids.work_permit_b', 'Work permit B'),
    value: WORK_PERMIT_B,
    reqexp:
      /^\d{4}\.\d{4}\/\d$|\d{3}\.\d{3}\.\d{3}-\d$|\d{9}\.\d$|[A-Z]{2}\d{6}$|\d{4}\/\d{1}$|\d{7}\.\d$|\d{8}\.\d$/,
    formats: [
      '1234.1234/1',
      '123.123.123-1',
      '123456789.1',
      '1234/1',
      '1234567.1',
      '12345678.1',
    ],
  },
  {
    label: t('ids.work_permit_c', 'Work permit C'),
    value: WORK_PERMIT_C,
    reqexp:
      /^\d{4}\.\d{4}\/\d$|\d{3}\.\d{3}\.\d{3}-\d$|\d{9}\.\d$|[A-Z]{2}\d{6}$|\d{4}\/\d{1}$|\d{7}\.\d$|\d{8}\.\d$/,
    formats: [
      '1234.1234/1',
      '123.123.123-1',
      '123456789.1',
      '1234/1',
      '1234567.1',
      '12345678.1',
    ],
  },
  {
    label: t('ids.work_permit_g', 'Work permit G'),
    value: WORK_PERMIT_G,
    reqexp:
      /^\d{4}\.\d{4}\/\d$|\d{3}\.\d{3}\.\d{3}-\d$|\d{9}\.\d$|[A-Z]{2}\d{6}$|\d{4}\/\d{1}$|\d{7}\.\d$|\d{8}\.\d$/,
    formats: [
      '1234.1234/1',
      '123.123.123-1',
      '123456789.1',
      '1234/1',
      '1234567.1',
      '12345678.1',
    ],
  },
  {
    label: t('ids.diplomatic_passport', 'Diplomatic Passport'),
    value: DIPLOMATIC_PASSPORT,
    reqexp: /^[a-zA-Z]\d{8}$/,
    formats: ['A99999999'],
  },
];

export const IDENTITY_DOCUMENTS_TYPES = [
  SWISS_ID,
  SWISS_PASSPORT,
  WORK_PERMIT_L,
  WORK_PERMIT_B,
  WORK_PERMIT_C,
  WORK_PERMIT_G,
  DIPLOMATIC_PASSPORT,
];
